import { render, staticRenderFns } from "./PaginationBarView.vue?vue&type=template&id=50e566b0&scoped=true&"
import script from "./PaginationBarView.vue?vue&type=script&lang=js&"
export * from "./PaginationBarView.vue?vue&type=script&lang=js&"
import style0 from "./PaginationBarView.vue?vue&type=style&index=0&id=50e566b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e566b0",
  null
  
)

export default component.exports